<script setup lang="ts">
import type { AlertProps } from '@/types/components/AlertComponent'

defineProps<Partial<AlertProps>>()
</script>
<template>
    <div role="alert" :class="`toast is-${type}`">
        {{ message }}
    </div>
</template>
